import styled, {ThemeProps} from 'styled-components';

import ArrowRightDetailsOneIcon from '../../../../Icons/ArrowRightDetailsOneIcon';
import LeftArrowIcon from '../../../../Icons/LeftArrowIconHome';

import {Theme} from './../../../../theme/types';
import {
  Column,
  ColumnW100Div,
  ColumnW100Styles,
  ColumnStyles,
} from './../../common/Layouts/Layouts';
import RightArrowIcon from '../../../../Icons/RIghtArrowIconHome';
import Image from '../../common/Image/Image';
import UserIcon from '../../../../../stories/Icons/UserIcon';

export const WrapperDiv = styled(Column)(
  (props: ThemeProps<Theme>) => `
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.base};
`,
);

export const MainImageWrapperDivStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  height: 20.6rem;
`;

export const PopupOverlayStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left:0;
  width:100%;
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
  background-color: ${props.theme.colors.shadow.dark};
  z-index: 999;
`,
);

export const PopupBodyStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  max-width: 130rem;
  max-height: 62rem;
  width:100%;
  display: flex;
  flex-direction: column;
  border-radius: ${props.theme.misc.borderRadius.xlarge};
`,
);

export const ContentTextOuterWrap = styled.div(
  (props: ThemeProps<Theme>) => `

  display: flex;

`,
);

export const CloseIconWrapperStyle = styled.div(
  props => `
  cursor: pointer;
  text-align: right;
  padding-bottom: ${props.theme.spacing.base};

  `,
);

export const OuterContainerGallery = styled.div(
  props => `

  display:flex;
  flex-direction: column;
  margin: ${props.theme.spacing.nospacing} auto;

  `,
);

export const InfoGalleryTitleWrap = styled.p(
  props => `

  font-size:${props.theme.font.large.font18};
  color:${props.theme.colors.black.base};
  font-weight:bold;
  // margin-bottom: ${props.theme.spacing.large.l15};

  `,
);

export const InfoGallerySubTitleWrap = styled.p(
  props => `

  font-size:${props.theme.font.base};
  color:${props.theme.colors.grey.grey75};
  margin-bottom: ${props.theme.spacing.large.l15};

  `,
);

export const InfoGalleryDescription = styled.p(
  props => `

  font-size:${props.theme.font.large.font14};
  color:${props.theme.colors.black.base};
  line-height:1.3;

  `,
);

export const UserDetailsOuterWrap = styled.div(
  props => `

  display:flex;

  `,
);

export const UserDetails = styled.div(
  props => `

  display:flex;
  flex-direction:column;

  `,
);

export const UserNew = styled(UserIcon)(
  props => `

    height:3rem;
    fill:grey;
    padding-right:${props.theme.spacing.large.l20};
    margin-top: ${props.theme.spacing.small.s5};
  `,
);

export const ContentWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  // overflow: hidden;
  ${ColumnW100Styles}
  background-color: ${props.theme.colors.black.base};
  padding: 3rem 5.5rem ${props.theme.spacing.large.l15} 5.5rem;
  // width: 100rem!important;
  border-radius: ${props.theme.misc.borderRadius.xlarge};
`,
);

export const InfoWrapperDiv = styled.div(
  props => `

  background-color: ${props.theme.colors.white.base};
  color: ${props.theme.colors.black.base};
  padding: ${props.theme.spacing.large.l15};

`,
);

export const MainImageWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnW100Styles}
  padding-bottom: ${props.theme.spacing.large.l15};
  position: relative;
`,
);

export const MainImageWrapper = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnW100Styles}
  padding-bottom: ${props.theme.spacing.large.l15};
  display: inline-block;
  width: 100%;
  height: 45rem;
  z-index: 1000;
`,
);

export const MainImageStyle = styled(Image)(
  (props: ThemeProps<Theme>) => `
  display: inline-block;
  width: 100%;
  z-index: 9999;
  height: 100%;
  // object-fit: contain;
  height: 45rem;
  position: absolute;
  border-radius: ${props.theme.misc.borderRadius.base};
`,
);

export const UserReviewTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `
line-height: 1.4;
font-size: ${props.theme.font.large.font16};
text-decoration: none!important;

&.active {
  font-weight: 600;
}
`,
);

export const LoaderImage = styled(Image)(
  (props: ThemeProps<Theme>) => `
  width: 35%;
  height: 40%;
  position: absolute;
  top: 35%;
  left: 35%;
`,
);

export const RoomLabelTextStyle = styled.span(
  (props: ThemeProps<Theme>) => `
  font-size: ${props.theme.font.large.font16};
  color: white;
  font-weight: bold;
`,
);

export const ArrowIconWrapperStyle = styled.span(
  (props: ThemeProps<Theme>) => `
  background-color: ${props.theme.colors.white.base};
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
`,
);

export const LeftIconWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnStyles}
  transform: translateX(-50%);
  left: -3rem;
  top: 50%;
  position: absolute;
  cursor: pointer;
`,
);

export const RightIconWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnStyles}
  transform: translateY(-50%);
  right: -4rem;
  top: 50%;
  position: absolute;
  cursor: pointer;
`,
);

export const ImageListWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  overflow: auto;
`,
);

export const ImageItemStyle = styled(Image)(
  props => `

  display: inline-block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  width: 12rem;
  height: 6.7rem;
  border-radius: ${props.theme.misc.borderRadius.base};

  `,
);

export const ImageGalleryUl = styled.ul(
  props => `

  align-items: center;
  overflow: hidden;
  flex-direction: row;
  display: flex;
  width: 92rem;
  > li {
    width: 120px;
    height: 70px;
    margin-right: 13px;
    flex-direction: row;
    &.active {
      border: 2px solid #fff;
      width: 124px;
      height: 70px;
      border-radius: ${props.theme.misc.borderRadius.base};
    }
  }

  `,
);

export const PhotoTypeTabUl = styled.ul(
  props => `
  width: 100%;
  flex-direction: row;
  color: white;
  display: flex;
  padding-bottom: 20px;
  > li {
    display: flex;
    color: white;
    /* padding: 10px; */
    margin-right:${props.theme.spacing.large.l20};
    font-size: 14px;
    cursor: pointer;
    &.active {
      border-bottom: 2px solid white;
      padding-bottom: ${props.theme.spacing.small.s5};
      font-weight: bold;
    }
  }
  `,
);

export const ImageItemWrapperStyle = styled.span(
  (props: ThemeProps<Theme>) => `
  cursor: pointer;
  display: inline-flex;
  line-height: 1;
`,
);

export const RoomLabelWrapperStyle = styled.div(
  (props: ThemeProps<Theme>) => `
  ${ColumnStyles}
  position: absolute;
  bottom: -10px;
  right: -12.5rem;
  width: 25rem;
  height: 5rem;
  // bottom: 2rem;
  // left: 50%;
  background-color: ${props.theme.colors.black.base};
  // border-radius: 2.5rem;
  border-radius: 1rem 0 0 0;
  padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.base};
  transform: translate(-50%, -50%);
  z-index: 9999;
  justify-content: center;
  align-items: center;
`,
);

export const LeftArrowGalleryTraveller = styled(LeftArrowIcon)(
  props => `
      width:1.5rem;
      height:1.5rem;
      fill:grey;
      position :absolute;
      top:0.9rem;
      left:0.9rem;
  `,
);

export const RightArrowGalleryTraveller = styled(RightArrowIcon)(
  props => `
      width:1.5rem;
      height:1.5rem;
      fill:grey;
      position :absolute;
      top:0.9rem;
      right:0.9rem;
  `,
);
